function matchheight() {
  $(".section-multi-column .text-column .text-column__image").matchHeight();
  $(".section-multi-column .text-column .text-column__title").matchHeight();
  $(".section-multi-column .text-column .text-column__text").matchHeight();
 
  $(".article h2").matchHeight();
  $(".article .rte").matchHeight();
  $(".article .meta").matchHeight();
  $(".about-us-page .section-logo-list .logo-list .logo-list__logo-image img").matchHeight();
  $(".about-us-page .section-logo-list .logo-list .logo-list__logo-title").matchHeight();
  $("body:is(.contact-page,.order-amp-corporate-enquiry-page,.events-page) .bcontact-form .bcontact-field>label").matchHeight();
  $("body .navigation .navigation__columns .navigation__column:not(.navigation__column--promotion) .navigation__column-title").matchHeight();
  
  
}

$(window).on("load", function () {    
 matchheight();
});

const timeID = setInterval(matchheight2, 5000);
function matchheight2() {
  //$(".product-block .product-block__detail .product-block__title").matchHeight();
}
$(window).on("load", function () {    
 matchheight2();
});

jQuery(document).ready(function() {
  setTimeout(function() {
   //$( ".quantity-class" ).appendTo( ".gpo-container" );
    $("#results-slt .content-results-slt .item .item-thumb").matchHeight();
    $("#results-slt .content-results-slt .item .item-content > label").matchHeight();
    $("#results-slt .content-results-slt .item .item-content > .address").matchHeight();
    $("#results-slt .content-results-slt .item .item-content > .item-phone").matchHeight();
    $("#results-slt .content-results-slt .item .item-content > .tag-item").matchHeight();
  }, 2000);
});

jQuery(document).ready(function() {
  setTimeout(function() {
   
    jQuery(document).ready(function(){
  jQuery("#accountIcon").click(function () {
      //jQuery("body .eber-container").css("display","block");
     //jQuery(".eber-btn-open-widget").addClass("eber-active");
     jQuery(".eber-btn-open-widget").trigger("click");
   });
});
  }, 2000);
});



